export default __webpack_public_path__ + "static/media/Engine.3fb87f60.jpg";